<h4 class="card-title mb-3 main-title">{{ "PatientRecord.steps.conditions" | translate }}</h4>

<h5 class="mb-3 sub-title">{{ "PatientRecord.steps.fillInConditions" | translate }}</h5>

<app-medical-record [showCategories]="['medication', 'conditions']"></app-medical-record>
